module.exports = __webpack_public_path__ + "img/bs8.6a853c84.png";